<template>
  <i
    :class="[iconName]"
    :style="[colorStyle, fontSizeStyle]"
    class="fma-icon"
  />
</template>

<script>
import Icons from './Icon.list';

export default {
  name: 'DDMCAF-Icon',
  props: {
    color: {type: String, default: ''},
    colorHex: {type: String, default: ''},
    size: {type: String, default: '24px'},
    icon: {type: String, required: true, validator: (value) => Object.values(Icons).includes(value)},
  },
  computed: {
    iconName() {
      if (this.icon) return this.icon.trim();
      if (this.$slots.default) return this.$slots.default[0].text.trim();
      return '';
    },
    colorStyle() {
      // if (this.colorHex && (/^#[0-9a-f]{3,6}$/i).test(this.colorHex)) return {color: this.colorHex};
      return {color: this.color};
    },
    fontSizeStyle() {
      return {fontSize: this.size};
    }
  }
}
</script>

<style lang="scss">
/*******************
The icon font is generated using icomoon.io/app. The file <project-root>/resources/assets/FMA-icons.json
can be imported and modified in the icomoon app.
*******************/
@import "../../assets/DDMCAF/fonts/icons/FMA-icons.css";

.fma-right-outline {
  rotate: 270deg;
  &:before { content: "\e90a"; }
}

</style>
